<template>
  <terms />
</template>
<script>
import Terms from '@/components/terms/index.vue'
export default {
  components: { Terms }
}
</script>
